import type { AppState } from '@constants/types'
import type { Metric } from '@shared_types/vessel_data'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import useSocket from './useSocket'

export default function useVesselPosition () {
  const position = useSelector((state: AppState) => state.main.position)
  const [vesselPosition, setVesselPosition] = useState({
    lat: position.value.lat,
    lng: position.value.lng
  })

  useSocket<Metric>('main.lat', evt => {
    setVesselPosition(pos => ({ ...pos, lat: evt.value }))
  })
  useSocket<Metric>('main.lng', evt => {
    setVesselPosition(pos => ({ ...pos, lng: evt.value }))
  })

  return vesselPosition
}
